import { motion } from 'framer-motion';
import { BUSINESS_INFO } from '../../constants';
import { dispararConversaoWhatsApp } from '../../utils/gtag';
import './contact.scss';

export default function Contact() {
  const handleWhatsApp = () => {
    dispararConversaoWhatsApp(() => {
      window.open(BUSINESS_INFO.whatsappUrl, '_blank', 'noopener,noreferrer');
    });
  };

  const handleCall = () => {
    window.location.href = 'tel:+5531999901010';
  };

  return (
    <section className="contact" id="contato">
      <div className="container">
        <motion.div 
          className="contact-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="contact-title">Dúvidas rápidas? Fale com a gente.</h2>

          <div className="contact-methods">
            <motion.div 
              className="contact-item"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="contact-icon">
                <i className="ri-whatsapp-line"></i>
              </div>
              <div className="contact-info">
                <h4>WhatsApp</h4>
                <p>(31) 99990-1010</p>
              </div>
            </motion.div>

            <motion.div 
              className="contact-item"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="contact-icon">
                <i className="ri-phone-line"></i>
              </div>
              <div className="contact-info">
                <h4>Telefone</h4>
                <p>(31) 99990-1010</p>
              </div>
            </motion.div>
          </div>

          <motion.div 
            className="contact-cta"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <button onClick={handleWhatsApp} className="contact-btn primary">
              <i className="ri-whatsapp-line"></i>
              Falar no WhatsApp
            </button>
            <button onClick={handleCall} className="contact-btn secondary">
              <i className="ri-phone-line"></i>
              Ligar agora
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
